module.exports = __webpack_public_path__ + "static/media/arrow-down-black.c1c2c1ce.svg";